import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  firstName: '',
  middleName: '',
  lastName: '',
  professionalSummary: '',
  basis: '',
  currencies: '',
  minSalary: 0,
  maxSalary: 0,
  email: '',
  contactNumber: '',
  city: '',
  country: '',
  address: '',
  zipCode: '',
  experiences: [],
  educationalBackground: [],
  professionalHeadlines: [],
  characterReferences: [],
  technicalSkills: [],
  softSkills: [],
  cvImageLink: '',
  cvImageFile: null,
}

const applicantSlice = createSlice({
  name: 'applicant',
  initialState,
  reducers: {
    setId: (state, action) => {
      state.id = action.payload
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload
    },
    setMiddleName: (state, action) => {
      state.middleName = action.payload
    },
    setLastName: (state, action) => {
      state.lastName = action.payload
    },
    setProfessionalSummary: (state, action) => {
      state.professionalSummary = action.payload
    },
    setBasis: (state, action) => {
      state.basis = action.payload
    },
    setCurrencies: (state, action) => {
      state.currencies = action.payload
    },
    setMinSalary: (state, action) => {
      state.minSalary = action.payload
    },
    setMaxSalary: (state, action) => {
      state.maxSalary = action.payload
    },
    setEmail: (state, action) => {
      state.email = action.payload
    },
    setContactNumber: (state, action) => {
      state.contactNumber = action.payload
    },
    setCity: (state, action) => {
      state.city = action.payload
    },
    setCountry: (state, action) => {
      state.country = action.payload
    },
    setAddress: (state, action) => {
      state.address = action.payload
    },
    setZipCode: (state, action) => {
      state.zipCode = action.payload
    },
    setExperiences: (state, action) => {
      state.experiences = [...action.payload].sort((a, b) => {
        const dateA = new Date(a.experienceFrom).valueOf() || 0
        const dateB = new Date(b.experienceFrom).valueOf() || 0
        return dateB - dateA
      })
    },
    setEducationalBackground: (state, action) => {
      state.educationalBackground = [...action.payload].sort((a, b) => {
        const dateA = new Date(a.from).valueOf() || 0
        const dateB = new Date(b.from).valueOf() || 0
        return dateB - dateA
      })
    },

    setProfessionalHeadlines: (state, action) => {
      state.professionalHeadlines = action.payload
    },
    setCharacterReferences: (state, action) => {
      state.characterReferences = action.payload
    },
    setTechnicalSkills: (state, action) => {
      state.technicalSkills = action.payload
    },
    setSoftSkills: (state, action) => {
      state.softSkills = action.payload
    },
    setCvImageLink: (state, action) => {
      state.cvImageLink = action.payload
    },
    setCvImageFile: (state, action) => {
      state.cvImageFile = action.payload
    },
  },
})

export const {
  setId,
  setFirstName,
  setMiddleName,
  setLastName,
  setProfessionalSummary,
  setBasis,
  setCurrencies,
  setMinSalary,
  setMaxSalary,
  setEmail,
  setContactNumber,
  setCity,
  setCountry,
  setExperiences,
  setEducationalBackground,
  setAddress,
  setZipCode,
  setProfessionalHeadlines,
  setCharacterReferences,
  setTechnicalSkills,
  setSoftSkills,
  setCvImageLink,
  setCvImageFile,
} = applicantSlice.actions

export default applicantSlice.reducer
